import { Route, Routes } from 'react-router-dom'
import RouteGuard from '../../global/Auth/RouteGuard.tsx'
import { appRoles } from '../../global/config.tsx'
import EventDetails from './eventDetails.tsx'
import { EventList } from './eventList.tsx'

const _eventRoutes = () => {
  return (
    <Routes>
      <Route>
        {/* Events */}
        <Route
          path="/"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <EventList />
            </RouteGuard>
          }
        />
        <Route
          path="/:eventId"
          element={
            <RouteGuard roles={[appRoles.Dozent, appRoles.Intern]}>
              <EventDetails />
            </RouteGuard>
          }
        />
      </Route>
    </Routes>
  )
}

export default _eventRoutes
